/* eslint-disable */

import { useState } from "react";
import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import { fetchGraphQL } from "../../../services/api-raindrop";
import { Size } from "../../../logic/enums.ts";
import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import RaindropTextHeading1 from "../../../ui-components/raindrop-text-heading-1/raindrop-text-heading-1.tsx";
import RaindropBackButtonPanel from "../../../ui-components/raindrop-back-button-panel/raindrop-back-button-panel.tsx";

const RaindropPasswordReset = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  const isValidPassword = newPassword && newPassword === confirmPassword;

  const onClickSubmit = () => {
    fetchGraphQL(`
            mutation {
                passwordReset(
                    newPassword: "${newPassword}",
                )
            }
        `)
      .then((response) => {
        setIsSuccess(true);
      })
      .catch((error) => {
        console.error("🔴 (RD-697) - ", error);
      });
  };

  if (isSuccess) {
    return (
      <div className="flex flex-col gap-4 py-8">
        <h2 className="font-bold text-4xl">Password reset</h2>
        <p>Your password has been reset successfully.</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 py-8 px-4">
      <RaindropBackButtonPanel />
      <RaindropCard additionalClasses="gap-4">
        <RaindropTextHeading1>Reset Password</RaindropTextHeading1>
        <RaindropInput
          value={newPassword}
          label="New password"
          example="New password"
          onChange={(e) => setNewPassword(e.target.value)}
          type="password"
          isPassword={true}
        />
        <RaindropInput
          value={confirmPassword}
          label="Confirm password"
          example="Confirm password"
          onChange={(e) => setConfirmPassword(e.target.value)}
          type="password"
          isPassword={true}
        />
        <RaindropButton
          title="Submit"
          onClick={onClickSubmit}
          isDisabled={!isValidPassword}
          size={Size.Large}
          style={ButtonStyle.Primary}
          isFluid={true}
        />
      </RaindropCard>
    </div>
  );
};

export default RaindropPasswordReset;
